// Re-export everything from the new blogUtils module
export type { BlogPost } from '../lib/blogUtils';
export { 
  getBlogPost,
  getBlogPostsByCategory,
  getRecentBlogPosts,
  getAllCategories,
  getAllBlogPosts
} from '../lib/blogUtils';

// For backward compatibility, export getAllBlogPosts result as blogPosts
import { getAllBlogPosts } from '../lib/blogUtils';
export const blogPosts = getAllBlogPosts();
